export default function getInitialState() {
  return {
    reactions: []
  };
}
